import { call, put, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import aiUsageService from '@/services/aiUsageService';
import { fetchAIUsageRequest, fetchAIUsageSuccess, fetchAIUsageFailure } from '../slices/aiUsageSlice';

function* fetchAIUsageWorker(): SagaIterator {
    try {
        const data = yield call([aiUsageService, aiUsageService.getMyUsage]);
        yield put(fetchAIUsageSuccess(data));
    } catch {
        yield put(fetchAIUsageFailure());
    }
}

function* watchAIUsage(): SagaIterator {
    yield takeLatest(fetchAIUsageRequest.type, fetchAIUsageWorker);
}

export default watchAIUsage;
